import { apolloClient } from '../apolloClient'
import { SYNC_USER } from './mutations/SYNC_USER'

export const syncUser = async () => {
  try {
    await apolloClient?.mutate({
      mutation: SYNC_USER,
    })
  } catch (e) {
    console.log('Error at sync user: ', e)
  }
}
